import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MyCloseIcon } from './img/close.svg'

type CloseIconProps = IconWrapperProps

export const CloseIcon: FC<CloseIconProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyCloseIcon />
    </IconWrapper>
  )
}
